import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import i18n from "../../../../i18n";

const ExportTaskAttendanceHistoryExcel = async (data) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Task Attendance History");
  const t = i18n.t.bind(i18n);

  worksheet.columns = [
    { header: t("taskAttendanceHistory.tableHeaders.workerName"), key: "workerName", width: 25 },
    { header: t("taskAttendanceHistory.tableHeaders.workerEmail"), key: "workerEmail", width: 30 },
    { header: t("taskAttendanceHistory.tableHeaders.department"), key: "workerDepartment", width: 20 },
    { header: t("taskAttendanceHistory.tableHeaders.taskName"), key: "taskName", width: 30 },
    { header: t("taskAttendanceHistory.tableHeaders.date"), key: "date", width: 15 },
    { header: t("taskAttendanceHistory.tableHeaders.taskLocation"), key: "taskLocation", width: 35 },
    { header: t("taskAttendanceHistory.tableHeaders.scheduledStart"), key: "scheduledStartTime", width: 15 },
    { header: t("taskAttendanceHistory.tableHeaders.actualStart"), key: "actualStartTime", width: 15 },
    { header: t("taskAttendanceHistory.tableHeaders.startStatus"), key: "startStatus", width: 15 },
    { header: t("taskAttendanceHistory.tableHeaders.startDelay"), key: "startDelay", width: 15 },
    { header: t("taskAttendanceHistory.tableHeaders.startLocationValidated"), key: "startLocationValidated", width: 20 },
    { header: t("taskAttendanceHistory.tableHeaders.startDistance"), key: "startDistance", width: 15 },
    { header: t("taskAttendanceHistory.tableHeaders.scheduledEnd"), key: "scheduledEndTime", width: 15 },
    { header: t("taskAttendanceHistory.tableHeaders.actualEnd"), key: "actualEndTime", width: 15 },
    { header: t("taskAttendanceHistory.tableHeaders.endStatus"), key: "endStatus", width: 15 },
    { header: t("taskAttendanceHistory.tableHeaders.endDelay"), key: "endDelay", width: 15 },
    { header: t("taskAttendanceHistory.tableHeaders.endLocationValidated"), key: "endLocationValidated", width: 20 },
    { header: t("taskAttendanceHistory.tableHeaders.endDistance"), key: "endDistance", width: 15 },
  ];

  // Transform data for Excel export
  const excelData = data.map((row) => ({
    workerName: row.workerName || "--",
    workerEmail: row.workerEmail || "--",
    workerDepartment: row.workerDepartment || "--",
    taskName: row.taskName || "--",
    date: row.date || "--",
    taskLocation: row.taskLocation || "--",
    scheduledStartTime: row.scheduledStartTime || "--",
    actualStartTime: row.actualStartTime || "--",
    startStatus: row.startStatus || "--",
    startDelay: row.startDelay || "--",
    startLocationValidated: row.startLocationValidated !== undefined ? (row.startLocationValidated ? "Yes" : "No") : "--",
    startDistance: row.startDistanceM !== null && row.startDistanceM !== undefined ? `${Number(row.startDistanceM).toFixed(1)}m` : "--",
    scheduledEndTime: row.scheduledEndTime || "--",
    actualEndTime: row.actualEndTime || "--",
    endStatus: row.endStatus || "--",
    endDelay: row.endDelay || "--",
    endLocationValidated: row.endLocationValidated !== undefined ? (row.endLocationValidated ? "Yes" : "No") : "--",
    endDistance: row.endDistanceM !== null && row.endDistanceM !== undefined ? `${Number(row.endDistanceM).toFixed(1)}m` : "--",
  }));

  worksheet.addRows(excelData);

  // Style header row
  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "003149" } };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.border = {
      top: { style: "thin" }, left: { style: "thin" },
      bottom: { style: "thin" }, right: { style: "thin" },
    };
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `Task_Attendance_History_${new Date().toISOString().slice(0,10)}.xlsx`);
};

export default ExportTaskAttendanceHistoryExcel;
